import { createAppSelector, sectionSelectors, sectionUserSelectors, termSelectors } from "./base";
import { sortByTermYearRegex } from "./sorting";

export const selectSortedTerms = createAppSelector([termSelectors.selectAll], (terms) =>
  terms.toSorted(sortByTermYearRegex),
);

export const selectSortedTermsForCurrentUser = createAppSelector(
  [
    sectionUserSelectors.filterForCurrentUser,
    sectionSelectors.selectEntities,
    termSelectors.selectEntities,
  ],
  (sectionUsers, sectionMap, termMap) => {
    const sectionIds = new Set(sectionUsers.map((cu) => cu.section_id));
    const termIds = new Set(
      Array.from(sectionIds).flatMap((sectionId) => {
        const section = sectionMap[sectionId];
        return section ? [section.term_id] : [];
      }),
    );
    return Array.from(termIds)
      .flatMap((termId) => {
        const term = termMap[termId];
        return term ? [term] : [];
      })
      .toSorted(sortByTermYearRegex);
  },
);
